import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Reports/hooks/useReportEntries.ts
function useReportEntries(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Reports.GetReportEntryList.v2, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.reportId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useReportEntries };

//# sourceMappingURL=useReportEntries.js.map